import angular from 'angular';

export default angular
	.module('ui.cian.utils.validateNotZero', [])
	.directive('cianUtilsValidateNotZero', () => {
		return {
			restrict: 'A',
			require: 'ngModel',
			link: (scope, element, attrs, ngModel) => {
				const checkZero = input => {
					let notZero = true; // set true first

					if (input !== null && !ngModel.$error.min && Number(input) === 0) {
						notZero = false;
					}

					return notZero;
				};
				ngModel.$validators.notZero = checkZero;
			}
		};
	})
	.name;
